/* eslint-disable camelcase */
import getCart from './getCart';
import updateCartCount from './updateCartCount';

const addToCart = async (variantId, qty, sellingPlan, properties) => {
  const item = {
    id: variantId,
    quantity: qty
  };

  if (sellingPlan) {
    item.selling_plan = sellingPlan;
  }
  if (properties && Object.keys(properties).length > 0) {
    item.properties = properties;
  }
  const items = { items: [item] };

  try {
    const atc = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(items)
    });
    const cart = await getCart();
    updateCartCount(cart.item_count);
    return await atc.json();
  } catch (err) {
    console.error('Add to cart error:', err);
  }
};

export default addToCart;
